import { createAction, props } from '@ngrx/store';
import { User } from '../../domains/users';
import { WorkOrder } from '../../domains/work/work-order/work-order.model';


export const appendMatchedInstaller = createAction(
  '[COMPONENT: Work Order Installer Options] (Matched Installer) Append',
  props<{ user: User, workOrder: WorkOrder }>()
)
